import {
  reopenReadTaskReadTasksReopenPatch,
  ReopenReadTaskReadTasksReopenPatchResponse,
  Body_reopen_read_task_read_tasks_reopen_patch,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useReopenTasksMutation = (): UseMutationResult<
  ReopenReadTaskReadTasksReopenPatchResponse,
  AxiosError<HTTPValidationError>,
  Body_reopen_read_task_read_tasks_reopen_patch
> => {
  return useMutation<
    ReopenReadTaskReadTasksReopenPatchResponse,
    AxiosError<HTTPValidationError>,
    Body_reopen_read_task_read_tasks_reopen_patch
  >({
    mutationFn: async (body) => {
      const response = await reopenReadTaskReadTasksReopenPatch({
        body: body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ReadTasksList'] })
    },
  })
}
